import { Route } from "react-router-dom";
import ReservationsByLocationAndNetworkScreen from "../../../container/Reservations/ReservationsByLocationAndNetworkScreen";
import { APP_URLS } from "../../../utils/constant";

const ReservationsByLocationAndNetworkRoutes = (access = {}) => {
  const { view } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RESERVATIONS_BY_LOCATION_AND_NETWORK.HOME}
          element={<ReservationsByLocationAndNetworkScreen />}
        />
      )}
    </>
  );
};

export default ReservationsByLocationAndNetworkRoutes;
